<template>
  <van-tabs v-model="activeTab" color="#1D2971" @change="onTabChange">
    <van-tab v-for="tab in tabList" :title="tab.title" :key="tab.title">
        <div v-if="dataList && dataList.length">
      <div v-for="i in dataList" :key="i.id">
        <div class="gap"></div>
        <div class="company">
          <div class="header">
            <div class="img-box">
              <img
                :src="i.logo"
                alt=""
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="info">
              <p class="title">{{i.compName}}</p>
              <p class="booth">展位号：{{ i.boothInfo }}</p>
            </div>
          </div>
          <div class="company-img-box">
            <img :src="i.fileUrls" alt="" style="width: 100%; height: 100%" />
          </div>
        </div>
      </div>
        </div>
        <div v-else class="empty">
    暂无数据
  </div>
    </van-tab>
  </van-tabs>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tabList: [
        { title: "首席合作", content: "首席合作" },
        { title: "联合共生", content: "联合共生" },
        { title: "联合共创", content: "联合共创" },
        { title: "共建单位", content: "共建单位" },
        { title: "同行单位", content: "同行单位" },
        { title: "论坛合作", content: "论坛合作" },
      ],
      dataList: [],
      activeTab: 0,
      exhibitionId: "",
      type: "",
    };
  },

  mounted() {
    const query = this.$route.query;
    this.exhibitionId = query.exhibitionId || "";
    this.type = query.type || "";
    this.getList(this.tabList[0].title);
  },

  methods: {
    async getList(tabName) {
      try {
        const res = await axios.post(
          "https://api.chccchina.com/api/v4/additionalemploysubmit/page/Cache",
          {
            page: 1,
            size: 10,
            exhibitionId: this.exhibitionId,
            exhibitorDefinitionKind: tabName,
            isSubmitted: true,
            sorting: "isShow desc",
            definitionName: this.type,
            definitionKind: '会刊广告',
          }
        );

        const list = res?.data?.items || [];

        // 先塞第一个 tab（后面可扩展分组）
        this.dataList = list;
      } catch (err) {
        console.log("getList error:", err);
      }
    },

    async onTabChange(index) {
        this.activeTab = index;
        // 根据 tab 获取当前标题
        const tab = this.tabList[index];
        await this.getList(tab.title);
    },
  },
};
</script>

<style scoped>
.gap {
  height: 12px;
  background: #f5f5f5;
}
.company {
  height: 590px;
  padding: 0 30px;
  background: #fff;
}
.header {
  height: 90px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
}

.img-box {
  width: 50px;
  height: 50px;
  margin-right: 12px;
  border-radius: 50%;
}

.info {
}

.title {
  color: #1d2971;
  font-size: 16px;
  font-weight: bold;
}

.booth {
  margin-top: 5px;
  color: #1d2971;
  font-size: 14px;
}

.company-img-box {
  margin: 10px 0;
  height: 480px;
}

.empty {
    padding: 60px 0;
    text-align: center;
    color: #999;
    font-size: 14px;
}
</style>